import * as ActionTypes from 'constants';
import {fetch} from  './connect';
import * as Actions from './';
import { callApi } from 'api';

export const fetchClientsFilters = f => ({
	type : ActionTypes.FETCH_CLIENTS_FILTERS
});

/** Complex function that does not reset the state */
export const fetchClientsWithFilters = options => ({ type: ActionTypes.FETCH_CLIENTS_WITH_FILTERS, payload: { options } });
/** Simple funciton that resets the state. Use when you want to empty the state before fetching. */
export const fetchClients = options => ({ type: ActionTypes.FETCH_CLIENTS, payload: { options } });
export const fetchNextClients = () => ({ type: ActionTypes.FETCH_NEXT_CLIENTS });
export const fetchPrevClients = () => ({ type: ActionTypes.FETCH_PREV_CLIENTS });
/** Used for clearing the selected client filters in the global state. */
export const clearClientsFilters = () => ({ type: ActionTypes.CLEAR_CLIENTS_FILTERS });
/** Used for clearing the downloaded filters in the global state. */
export const clearFetchedClientsFilters = f => ({ type: ActionTypes.CLEAR_FETCHED_CLIENTS_FILTERS });
export const setClientPageSize = size => ({ type: ActionTypes.SET_CLIENT_PAGE_SIZE, payload: { size } });
export const setClientSortColumn = column => ({ type: ActionTypes.SET_CLIENT_SORT_COLUMN, payload: { column } });
export const setClientsFilters = options => ({ type: ActionTypes.SET_CLIENTS_FILTERS, payload: { options } });
export const updateClientsBounds = bounds => ({ type: ActionTypes.UPDATE_CLIENTS_BOUNDS, payload: bounds});
export const addClientsFilter = filter => ({ type: ActionTypes.ADD_CLIENTS_FILTER, payload: { filter } });
export const showSelectingClientColumns = f => ({ type: ActionTypes.SHOW_SELECTING_CLIENT_COLUMNS })
export const hideSelectingClientColumns = f => ({ type: ActionTypes.HIDE_SELECTING_CLIENT_COLUMNS });
export const toggleClientColumn = column => ({ type: ActionTypes.TOGGLE_CLIENT_COLUMN, payload: { column } });
export const setClientColumns = (columns) => ({ type: ActionTypes.SET_CLIENT_COLUMNS, payload: columns });
export const updateClients = (clients) => ({ type : ActionTypes.UPDATE_CLIENTS, clients });
export const updateClientsFilters = filters => ({ type: ActionTypes.UPDATE_CLIENTS_FILTERS, payload: filters });
export const addClientError = (error) => ({ type: ActionTypes.ADD_CLIENT_ERROR, error });
export const clearClients = () => ({ type: ActionTypes.CLEAR_CLIENTS });
export const downloadingImpactReport = (bool) => ({ type: ActionTypes.DOWNLOADING_CLIENT_REPORT, payload: bool });
export const toggleFetchingClient = (bool) => ({ type: ActionTypes.TOGGLE_FETCHING_CLIENT, payload: bool });
export const toggleFetchingClients = bool => ({ type: ActionTypes.TOGGLE_FETCHING_CLIENTS, payload: bool });
export const toggleFilterClientsByMapBounds = bool => ({ type: ActionTypes.TOGGLE_FILTER_CLIENTS_TABLE_BY_MAP_BOUNDS, payload: bool });
export const toggleViewingClientsMap = bool => ({ type: ActionTypes.TOGGLE_VIEWING_CLIENTS_MAP, payload: bool });
export const updateClientsTableList = clients => ({ type: ActionTypes.UPDATE_CLIENTS_TABLE_LIST, payload: clients });
export const updateClientsMapList = clients => ({ type: ActionTypes.UPDATE_CLIENTS_MAP_LIST, payload: clients });
export const fetchClientsSucceeded = payload => ({ type: ActionTypes.FETCH_CLIENTS_SUCCEEDED, payload });
export const updateClientsTableOpenState = state => ({ type: ActionTypes.UPDATE_CLIENTS_TABLE_OPEN_STATE, payload: state });
export const selectClient = id => ({ type : ActionTypes.SELECT_CLIENT, payload : { id } });
export const zoomToClient = client_id => ({ type: ActionTypes.ZOOM_TO_CLIENT, payload: client_id });
export const updateTablePageSize = size => ({ type: ActionTypes.UPDATE_TABLE_PAGE_SIZE, payload: size });


// ******************* REDUX THUNKS ******************* //


export const getClients = () => {
	return function(dispatch) {
		dispatch(clearClients());
		callApi('POST', '/clients', {}, 'application/json')
			.then(clients => {
				dispatch(updateClients(clients));
			})
			.catch(error => {
				dispatch(addClientError(error));
			})
	}
}

export const getClient = (id, callback) => {
	return function(dispatch) {
		dispatch(clearClients());
		callApi('POST', `/client/${ id }`, {}, 'application/json')
			.then(client => {
				callback(null, client);
			})
			.catch(error => {
				callback(error, null);
			});
	}
}

export const addClient = (client, callback) => {

	var add = (client) => {
		return {
			type : ActionTypes.ADD_CLIENT,
			client
		}
	}

	return function(dispatch) {
		callApi('POST', '/clients/create', {}, 'application/json')
			.then(client => {
				dispatch(add(client))
        dispatch(selectClient(client._id));
        dispatch(Actions.receiveClient(client));
        if(callback)
  				callback(null, client);
			})
			.catch(error => {
				dispatch(addClientError(error));
        dispatch(Actions.notify( {message : error.message} ));
        if(callback)
  				callback(error, null);
			});
	}
}

export const updateClient = (client, callback) => {
	var update = (client) => {
		return {
			type : ActionTypes.UPDATE_CLIENT,
			client
		}
	}

	return function(dispatch) {
		callApi('PUT', `/clients/update/${ client._id }`, client, 'application/json')
			.then(client => {
				dispatch(update(client));
				if(typeof callback !== 'undefined')
					callback(null,client);
			})
			.catch(error => {
				dispatch(addClientError(error));
				if(typeof callback !== 'undefined')
					callback(error,null);
			});
	}
}

export const deleteAllClients = (callback) => {
	return (dispatch) => {
		callApi('POST', '/clients/delete/all', {}, 'application/json')
			.then(response => {
				dispatch(clearClients());
				if(typeof callback === 'function')
					callback(null, response);
			})
			.catch(error => {
				dispatch(addClientError(error));
				if(typeof callback === 'function')
					callback(error, null);
			});
	}
}

export const downloadXMLReport = (map_ids, callback) => {
	return (dispatch) => {
		dispatch(downloadingImpactReport(true));
		callApi('POST', '/clients/impact_report', {}, 'application/json')
			.then(response => {
				dispatch(downloadingImpactReport(false));
				if(response.tmp_url) {
					window.location = response.tmp_url;
				}
				if(typeof callback === 'function')
					callback(null, response);

			})
			.catch(error => {
				dispatch(downloadingImpactReport(false));
				if(typeof callback === 'function')
					callback(error, null);
			});
	}
}



// WEBPACK FOOTER //
// ./src/common/actions/clients.js